(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/banner_actions/quickplay/assets/javascripts/init.js') >= 0) return;  svs.modules.push('/components/banner_actions/quickplay/assets/javascripts/init.js');

'use strict';

const bannerHelpers = svs.banner_common.banner_helpers;
const Storage = svs.components.Storage;
const localStorageDomain = 'banner-actions-quickplay';
const QUICKPLAY_TYPES = {
  MIXEN_PACKAGES: {
    DATA_TYPE: 'mixenPackages',
    URL_PARAM_KEY: 'package'
  }
};
function handleMixenPackages() {
  var _svs$banner_layouts$b;
  let payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const {
    bannerLayoutType,
    bannerId,
    packageId
  } = payload;
  if (!bannerId || !bannerLayoutType) {
    return;
  }
  const packageConfig = (_svs$banner_layouts$b = svs.banner_layouts[bannerLayoutType]) === null || _svs$banner_layouts$b === void 0 || (_svs$banner_layouts$b = _svs$banner_layouts$b.data) === null || _svs$banner_layouts$b === void 0 ? void 0 : _svs$banner_layouts$b[QUICKPLAY_TYPES.MIXEN_PACKAGES.DATA_TYPE];
  const {
    data
  } = bannerHelpers.getMixenData(packageConfig, {
    package: packageId
  });
  if (!data) {
    return;
  }
  svs.ui.loader.show();
  svs.core.module.load("/cl/numbergames/pay-quickplay-packages?json=true&fetchDraws=true", null, () => {
    const saveState = redirectFn => {
      svs.utils.paramHandler.set({
        key: QUICKPLAY_TYPES.MIXEN_PACKAGES.URL_PARAM_KEY,
        value: bannerId
      });
      Storage.browser.set(bannerId, localStorageDomain, payload, Storage.constants.EXPIRES_1H, redirectFn);
    };
    const cleanup = () => {
      svs.utils.paramHandler.remove({
        key: QUICKPLAY_TYPES.MIXEN_PACKAGES.URL_PARAM_KEY
      });
      Storage.browser.remove(bannerId, localStorageDomain);
    };
    svs.ui.loader.hide();
    svs.numbergames.pay_quickplay_packages.makePayment({
      data,
      onSuccess: cleanup,
      onCancel: cleanup,
      saveState
    });
  }, false, false, false);
}
function initAction() {
  let payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  switch (payload.bannerDataType) {
    case QUICKPLAY_TYPES.MIXEN_PACKAGES.DATA_TYPE:
      handleMixenPackages(payload);
      break;
    default:
  }
}
function checkQueryParam() {
  if (svs.utils.paramHandler.get({
    key: 'pay'
  }).value) {
    const bannerId = svs.utils.paramHandler.get({
      key: QUICKPLAY_TYPES.MIXEN_PACKAGES.URL_PARAM_KEY
    }).value;
    svs.utils.paramHandler.remove({
      key: QUICKPLAY_TYPES.MIXEN_PACKAGES.URL_PARAM_KEY
    });
    if (!svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER)) {
      svs.utils.paramHandler.remove({
        key: 'pay'
      });
    } else if (bannerId) {
      Storage.browser.get(bannerId, localStorageDomain, initAction);
    }
  }
}
function clickEvent(event) {
  var _element$classList;
  const element = event.target.closest('.js-banner-actions-quickplay');
  if (element !== null && element !== void 0 && (_element$classList = element.classList) !== null && _element$classList !== void 0 && _element$classList.contains('js-banner-actions-quickplay')) {
    initAction(element.dataset);
  }
}
(() => {
  if (!document.body.classList.contains('has-banner-quickplay-clicks')) {
    document.body.classList.add('has-banner-quickplay-clicks');
    document.body.addEventListener('click', clickEvent);
    checkQueryParam();
  }
})();

 })(window);